import React from 'react';
import { visitorsOf } from '../../components/admin/dashboard/api';
import { useSummary } from '../../components/admin/dashboard/useSummary';
import { DashPage } from '../../components/admin/dashboard/DashPage';
import { VisitorsCard } from '../../components/admin/dashboard/VisitorsCard';
import { SourcesCard } from '../../components/admin/dashboard/SourcesCard';
import { BusyTimesCard } from '../../components/admin/dashboard/BusyTimesCard';
import { SiteHealthCard } from '../../components/admin/dashboard/SiteHealthCard';
import { DevicesCard } from '../../components/admin/dashboard/DevicesCard';

// Website analytics from PostHog (public site only): traffic over time, where visits come from,
// when they happen, how fast the site is and what people browse on. Same summary and date range
// as the Dashboard.
const Analytics: React.FC = () => {
  const s = useSummary();
  const v = visitorsOf(s.data);
  const loading = !s.data;
  return (
    <DashPage title="Analytics" s={s} layout="analytics">
      <VisitorsCard data={s.data?.visitors} rangeDays={s.days} />
      <SourcesCard v={v} loading={loading} />
      <BusyTimesCard v={v} loading={loading} />
      <SiteHealthCard v={v} loading={loading} />
      <DevicesCard v={v} loading={loading} />
    </DashPage>
  );
};

export default Analytics;
